module.exports = __webpack_public_path__ + "media/images/logos/ba-b0cbd60afbaff0cb7c55be720a9982f2.png";